define('config/ConfigManager', [
    'config/config.common',
    'config/config.development',
    'config/config.preproduction',
    'config/config.production'
], function(config, configDev, configPP, configProd) {

    var configEnv = {};

    switch (window.location.hostname) {
        case "localhost":
        case "diorgallerybackstage-site.local":
            configEnv = configDev;
            configEnv.deviceEnv = (config.queryString.mobile) ? "mobile" : "desktop";
            dataLayer.push({
                error: "",
                pageVirtualPath: "",
                univers: "PCD"
            });
            break;

        case "www.preprod.dior.com":
        case "www.pcdpreprod.dior.com":
        case "www.pcdpreprod.staging.dior.com":
        case "m.pcdpreprod.dior.com":
        case "www.current.recette.dior.com":
        case "www.current.recette.dior.cn":
        case "m.current.recette.dior.com":
        case "m.current.recette.dior.cn":
        case "m.pcdpreprod.dior.cn":
        case "www.pcdpreprod.dior.cn":
        case "preprod.dior.cn":
        case "m.preprod.dior.com":
        case "m.preprod.dior.cn":
            configEnv = configPP;
            configEnv.deviceEnv = (window.maz_rooturl.indexOf("m.pcdpreprod.dior.com") !== -1 ||
                                    window.maz_rooturl.indexOf("m.pcdpreprod.dior.cn") !== -1 ||
                                    window.maz_rooturl.indexOf("m.preprod.dior.com") !== -1 ||
                                    window.maz_rooturl.indexOf("m.preprod.dior.cn") !== -1 ||
                                    window.maz_rooturl.indexOf("m.current.recette.dior.com") !== -1 ||
                                    window.maz_rooturl.indexOf("m.current.recette.dior.cn") !== -1 ) ? "mobile" : "desktop";
            break;

        case "www.dior.com":
        case "www.dior.cn":
        case "m.dior.com":
        case "m.dior.cn":

        case "org-www.dior.com":
        case "org-m.dior.com":
        case "org-www.dior.cn":
        case "org-m.dior.cn":


            configEnv = configProd;
            configEnv.deviceEnv = (window.maz_rooturl.indexOf("m.dior.com") !== -1 ||window.maz_rooturl.indexOf("m.dior.cn") !== -1 || window.maz_rooturl.indexOf("org-m.dior.com") !== -1 || window.maz_rooturl.indexOf("org-m.dior.cn") !== -1) ? "mobile" : "desktop";
            break;

        default:
            console.warn('[ConfigManager] Warning hostname is not well configurate. It may cause errors.');
            configEnv = configProd;
            configEnv.deviceEnv = (config.queryString.mobile) ? "mobile" : "desktop";
            dataLayer.push({
                error: "",
                pageVirtualPath: "",
                univers: "PCD"
            });
            break;
    }

    _.extend(config, configEnv);

    return config;
});
